import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/image/首页学习贯彻党的四中全会精神.png'
import _imports_1 from '../assets/image/title.png'


const _hoisted_1 = { class: "all" }
const _hoisted_2 = { class: "part_one" }
const _hoisted_3 = { class: "show" }
const _hoisted_4 = { class: "swiper-column" }
const _hoisted_5 = { class: "notice" }
const _hoisted_6 = { class: "gonggao-container" }
const _hoisted_7 = { class: "gonggao-item dangjian" }
const _hoisted_8 = { class: "gonggao-content" }
const _hoisted_9 = { class: "meeting-list" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "meeting-time" }
const _hoisted_12 = { class: "gonggao-item weisheng" }
const _hoisted_13 = { class: "gonggao-content" }
const _hoisted_14 = {
  key: 0,
  class: "empty-placeholder"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "gonggao-container" }
const _hoisted_18 = { class: "gonggao-item fenhui" }
const _hoisted_19 = { class: "gonggao-content" }
const _hoisted_20 = {
  key: 0,
  class: "empty-placeholder"
}
const _hoisted_21 = {
  key: 1,
  class: "meeting-list"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "meeting-address" }
const _hoisted_24 = { class: "meeting-time" }
const _hoisted_25 = { class: "gonggao-item weisheng" }
const _hoisted_26 = { class: "gonggao-content" }
const _hoisted_27 = {
  key: 0,
  class: "empty-placeholder"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "part_two" }
const _hoisted_31 = { class: "part_three" }
const _hoisted_32 = { class: "images" }

import PaperContainer from '../components/paperContainer.vue';
import Swiper from '@/components/swiper.vue';
import NoticeList from '@/components/noticelist.vue';
import BoxChange from '@/components/boxChange/boxBottom.vue';
import { useRouter } from 'vue-router';
import { computed, ref, onMounted } from 'vue';
import { getNow, now } from '@/utils/getTime';
import { getSwiperList, getNoticeList, getNoticeSearch } from '@/api/index';
import emitter from '@/plugins/emitter';
import { getLatestMeetings } from '@/data/huiyi';
import { dangjian } from '@/data/dangjian';
import { getLatestJicengxunjiangArticles } from '@/data/weisheng';
import { getLatestDajiangtangArticles } from '@/data/dajiangtang';
// const swiperInstance = ref<any>(null);

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter()
// 通知公告、工作动态
const queryParams = ref({
  pageNum: 1,
  pageSize: 8,
  // searchVal: "",
  type: "1",
  category: "",
})
// 轮播数据
const swiperlist = ref([]);
// 数据列表
const noticelist = ref([]);
// 科普园地数据
const kepuList = ref([]);
// 卫生强基数据
const weishengList = ref(getLatestJicengxunjiangArticles());
// 大讲堂数据 - 独立的数据源
const dajiangtangList = ref(getLatestDajiangtangArticles());
const huiyiList = ref(getLatestMeetings());
// 轮播数据获取 第一版
// const getLunboList = async () => {
//   const res = await getSwiperList() as any;
//   swiperlist.value = res;
// }
// 轮播数据获取 第二版
// const getLunboList = async () => {
//   try {
//     const res = await getSwiperList() as any;
//     // 确保数据格式正确，包含id, img, title等必要字段
//     swiperlist.value = res.map(item => ({
//       id: item.newsId, // 使用newsId作为文章ID
//       img: item.fileUrl, // 图片URL
//       title: item.fileName // 可以使用文件名作为标题，或从关联的文章获取标题
//     }));
//   } catch (error) {
//     console.error('获取轮播图数据失败:', error);
//     swiperlist.value = []; // 失败时设置为空数组
//   }
// }
// 修正后的数据映射
const getLunboList = async () => {
  try {
    const res = await getSwiperList() as any;
    // 确保映射正确的字段名
    swiperlist.value = res.map(item => ({
      id: item.id || item.articleId, // 兼容不同字段名
      img: item.img || item.coverImage || item.fileUrl, // 兼容不同字段名
      title: item.title || item.articleTitle || item.fileName // 兼容不同字段名
    }));
    console.log('轮播图数据:', swiperlist.value); // 添加日志以便调试
  } catch (error) {
    console.error('获取轮播图数据失败:', error);
    swiperlist.value = [];
  }
}

// 处理卫生强基More点击
const handleWeishengMore = () => {
  router.push('/weisheng');
}

// 处理大讲堂More点击
const handleDajiangtangMore = () => {
  // 这里可以跳转到专门的大讲堂页面，或者保持当前页面
  // router.push('/dajiangtang');
  console.log('跳转到生活方式医学与慢病管理大讲堂页面');
}

//分会
const handleFenhuiMore = () => {
  router.push('/huiyi'); // 跳转到会议页面
}


// 动态公告菜单切换
const handleSelect = async (index: any) => {
  queryParams.value.type = index;
  sessionStorage.setItem('numberIdx', `1-${index}`);
  const { list } = await getNoticeList(queryParams.value) as any;
  noticelist.value = list;
}


// 更多
const getMore = (index: any) => {
  sessionStorage.setItem('changeTitle', '学会通知公告');
  emitter.emit('change-title', '学会通知公告');
  router.push({
    path: index == 1 ? '/learnNotice' : '/learnwork',
  })
}

// 处理公告栏点击
const handleGonggaoClick = (type: string) => {
  if (type === 'weisheng') {
    handleWeishengMore();
  } else if (type === 'dangjian') {
    router.push('/dangjian');
  } else if (type === 'kepu') {
    router.push('/kepu');
  } else if (type === 'dajiangtang') {
    router.push('/jiangtang');
  }else if (type === 'fenhui') {
    handleFenhuiMore(); // 添加分支机构活动处理
  }
}

onMounted(async () => {
  getNow();
  // 轮播数据
  getLunboList();
  // 通知公告
  handleSelect(queryParams.value.type);
  // 这里可以添加获取科普园地和卫生强基数据的逻辑
  // getKepuList();
  // getWeishengList();
})


// const displayedMeetings = computed(() => {
//   return [...meetings]
//     .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
//     .slice(0, 5)
//     .reverse(); // 反转数组
// });
const displayedDangjian = computed(() => {
  return [...dangjian]
    .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
    .slice(-5)
    .reverse(); // 反转数组
});


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_FirstAidKit = _resolveComponent("FirstAidKit")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createBlock(PaperContainer, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "pic" }, [
            _createElementVNode("a", {
              href: "https://www.12371.cn/special/20jsizqh/",
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                srcset: ""
              })
            ]),
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              srcset: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Swiper, {
                "is-choose-type": 1,
                list: swiperlist.value,
                onSwiper: _cache[0] || (_cache[0] = (swiper) => _ctx.swiperInstance.value = swiper)
              }, null, 8, ["list"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_menu, {
                "default-active": queryParams.value.type,
                class: "el-menu-demo",
                mode: "horizontal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: '1',
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (handleSelect('1')))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("通知公告")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: '2',
                    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (handleSelect('2')))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("工作动态")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "more",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (getMore(queryParams.value.type)))
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("p", null, "More", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRightBold)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["default-active"]),
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(NoticeList, {
                    key: queryParams.value.type,
                    dataList: noticelist.value
                  }, null, 8, ["dataList"]))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("党建动态")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "more",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleGonggaoClick('dangjian')))
                  }, [
                    _cache[12] || (_cache[12] = _createElementVNode("p", null, "More", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRightBold)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedDangjian.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "meeting-item",
                      key: index
                    }, [
                      _createElementVNode("a", {
                        href: item.url,
                        target: "_blank",
                        class: "meeting-name"
                      }, _toDisplayString(item.name), 9, _hoisted_10),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(item.time), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("卫生强基")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "more",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleGonggaoClick('weisheng')))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("p", null, "More", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRightBold)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_13, [
                (!weishengList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FirstAidKit)
                        ]),
                        _: 1
                      }),
                      _cache[15] || (_cache[15] = _createElementVNode("p", null, "暂无卫生强基文章", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weishengList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("a", {
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(item.title), 9, _hoisted_16),
                          _createElementVNode("span", null, _toDisplayString(item.date), 1)
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("分支机构活动")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "more",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (handleGonggaoClick('fenhui')))
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("p", null, "More", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRightBold)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_19, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "meeting-header" }, [
                  _createElementVNode("div", { class: "header-item" }, "会议名称"),
                  _createElementVNode("div", { class: "header-item" }, "会议地址"),
                  _createElementVNode("div", { class: "header-item" }, "会议时间")
                ], -1)),
                (!huiyiList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Calendar)
                        ]),
                        _: 1
                      }),
                      _cache[18] || (_cache[18] = _createElementVNode("p", null, "暂无会议信息", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(huiyiList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "meeting-item",
                          key: index
                        }, [
                          _createElementVNode("a", {
                            href: item.url,
                            target: "_blank",
                            class: "meeting-name"
                          }, _toDisplayString(item.name), 9, _hoisted_22),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.address), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.time), 1)
                        ]))
                      }), 128))
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_menu, { class: "custom-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("生活方式医学与慢病管理大讲堂")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "more",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleGonggaoClick('dajiangtang')))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "More", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRightBold)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_26, [
                (!dajiangtangList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FirstAidKit)
                        ]),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createElementVNode("p", null, "暂无生活方式医学与慢病管理大讲堂内容 ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dajiangtangList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("a", {
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(item.title), 9, _hoisted_29),
                          _createElementVNode("span", null, _toDisplayString(item.date), 1)
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(BoxChange)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("div", { class: "line" }),
            _createElementVNode("div", { class: "title-item" }, [
              _createElementVNode("h2", null, "友情链接"),
              _createElementVNode("p", null, "ZHENG WU GONG KAI")
            ]),
            _createElementVNode("div", { class: "line" })
          ], -1)),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(Swiper, { "is-choose-type": 2 })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})